import { AttachFile, Code, Draw, Flag, Google, GridOn, Handshake, InsertDriveFile, Lightbulb, Notes, Quiz, School, Star, TipsAndUpdates, Videocam, YouTube } from "@mui/icons-material";
import { txt } from "../services/translation";

const sectionTypes = [
    {
        id: 'video',
        title: txt('videoType'),
        icon: <Videocam color='action' sx={{width: 20}} />,
        public: true,
        mediaLabel: txt('videoMediaLabel'),
    },
    {
        id: 'youtube',
        title: txt('youtubeType'),
        icon: <YouTube color='action' sx={{width: 20}} />,
        public: false,
        mediaLabel: txt('youtubeMediaLabel'),
    },
    {
        id: 'html',
        title: txt('htmlType'),
        icon: <Notes color='action' sx={{width: 20}} />,
        public: true,
    },
    {
        id: 'google',
        title: txt('googleType'),
        icon: <Google color='action' sx={{width: 20}} />,
        public: false,
        mediaLabel: txt('googleMediaLabel'),
    },
    {
        id: 'download',
        title: txt('downloadType'),
        icon: <AttachFile color='action' sx={{width: 20}} />,
        public: true,
        extension: '.zip',
    },
    {
        id: 'quiz',
        title: txt('quizType'),
        icon: <Quiz color='action' sx={{width: 20}} />,
        public: true,
    },
    {
        id: 'pdf',
        title: txt('pdfType'),
        icon: <InsertDriveFile color='action' sx={{width: 20}} />,
        public: true,
        extension: '.pdf',
    },
    {
        id: 'review',
        title: txt('reviewType'),
        icon: <Star color='action' sx={{width: 20}} />,
        public: true,
    },
    {
        id: 'evaluation_start',
        title: txt('evaluationStartType'),
        icon: <Quiz color='action' sx={{width: 20}} />,
        public: false,
    },
    {
        id: 'evaluation_end',
        title: txt('evaluationEndType'),
        icon: <Quiz color='action' sx={{width: 20}} />,
        public: false,
    },
    {
        id: 'audit_before',
        title: txt('auditBeforeType'),
        icon: <GridOn color='action' sx={{width: 20}} />,
        public: false,
    },
    {
        id: 'audit_after',
        title: txt('auditAfterType'),
        icon: <GridOn color='action' sx={{width: 20}} />,
        public: false,
    },
    {
        id: 'audit_reco',
        title: txt('auditRecoType'),
        icon: <TipsAndUpdates color='action' sx={{width: 20}} />,
        public: false,
    },
    {
        id: 'audit_actions',
        title: txt('improvementsType'),
        icon: <Flag color='action' sx={{width: 20}} />,
        public: false,
    },
    {
        id: 'participation',
        title: txt('participationType'),
        icon: <Draw color='action' sx={{width: 20}} />,
        public: false,
    },
    {
        id: 'view',
        title: txt('viewType'),
        icon: <Lightbulb color='action' sx={{width: 20}} />,
        public: false,
    },
    {
        id: 'certificate',
        title: txt('certificateType'),
        icon: <School color='action' sx={{width: 20}} />,
        public: true,
    },
    {
        id: 'notion',
        title: txt('notionType'),
        icon: <Notes color='action' sx={{width: 20}} />,
        public: false,
    },
    {
        id: 'sponsor',
        title: txt('sponsorType'),
        icon: <Handshake color='action' sx={{width: 20}} />,
        public: false,
    },
    {
        id: 'custom',
        title: txt('customType'),
        icon: <Code color='action' sx={{width: 20}} />,
        public: false,
    },
];


export default sectionTypes;

